export class RoutesGlossary {
    public static readonly Same: string = "_self";

    /* AuthController */
    public static readonly Login: string = "Auth/LogIn";
    public static readonly LoginAas: string = "Auth/LoginAas";
    public static readonly LoginDomain: string = "Auth/LoginDomain";
    public static readonly GetKrbUser: string = "Auth/GetKrbUser";
    public static readonly GetCurrentUser: string = 'Auth/GetCurrentUser';
    public static readonly RenewAasSession: string = 'Auth/RenewAasSession';
    public static readonly Logout: string = 'Auth/Logout';

    /* WebAdminController */
    public static readonly WebAdmin: string = "WebAdmin";

    /* ConfigurationApiController */
    public static readonly GetAuthConfig: string = 'api/webapp/configuration/get-auth-config';
    public static readonly GetAasConfig: string = 'api/webapp/configuration/get-aas-config';
    public static readonly GetIdsLsConfig: string = 'api/webapp/configuration/get-ls-config';

    /* LicenseApiController */
    public static readonly GetLicenseInfo: string = 'api/webapp/license/get-license-info';
}